import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const InitGuard = ({ children }) => {
  const statusData = useSelector((state) => state.user.statusData);

  return useMemo(() => {
    if (statusData.bear_type !== null) {
      // 有選過熊
      return <Navigate to="/" replace />;
    }

    return children;
  }, []);
};

export default InitGuard;
